import en from './strings.en';

const ru = {
    addToList: 'Добавить в список',
    inviteToBoard: 'Пригласить на площадку',
    openPassport: 'Открыть паспорт'
};

export default { ru, en: { ...ru, ...en} };
